module.exports = __webpack_public_path__ + "static/media/hamburger-menu.11b12e33.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hamburger-menu.svg
// module id = 629
// module chunks = 0